<template>
  <div class="filter-list-editor">
    <div
      v-for="(filter, idx) in vModel"
      :key="idx"
      :class="{'error-border': childErrors(idx, errors).length > 0}"
      class="list-item">
      <FilterConfigEditor
        :value="filter"
        :errors="childErrors(idx, errors)"
        :default-time-range="defaultTimeRange"
        :default-time-range-label="defaultTimeRangeLabel"
        @input="updateFilter(idx, $event)" />
      <button
        class="delete"
        @click="deleteFilter(idx)" />
    </div>
    <b-button @click.native="addFilter">
      Add Filter
    </b-button>
  </div>
</template>

<script>

  import ObjectEditorMixin from '@/components/reports/config/common/ObjectEditorMixin'
  import FilterConfigEditor from '@/components/reports/config/modules/common/FilterConfigEditor'
  import { childErrors as _childErrors } from '@/components/reports/config/common/validation'

  export default {
    name: 'FilterConfigListEditor',
    components: {
      FilterConfigEditor,
    },
    mixins: [ObjectEditorMixin,],
    props: {
      errors: {
        type: Array,
        default: () => [],
      },
      defaultTimeRange: {
        type: Object,
        default: null,
      },
      defaultTimeRangeLabel: {
        type: String,
        default: 'Use measure default',
      },
    },
    watch: {
      vModel: {
        handler (newVal) {
          this.$emit('input', newVal)
        },
        deep: true,
      },
    },
    methods: {
      childErrors: _childErrors,
      addFilter () {
        this.$set(this.vModel, this.vModel.length, {})
      },
      updateFilter (idx, filter) {
        this.$set(this.vModel, idx, filter)
      },
      deleteFilter (idx) {
        this.vModel.splice(idx, 1)
      },
    },
  }
</script>

<style lang="scss" scoped>
.filter-list-editor {
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.list-item {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  border: $border-1;
  border-radius: 4px;

  .delete {
    position: absolute;
    top: 5px;
    right: 5px;
  }
}

.filter-config-editor {
  flex-grow: 1;
  flex-direction: row;
}
</style>
